import { Event, Route } from '../interfaces';
import { useRoutes } from '../queries';
import { useFleet } from './useFleet';

export const useEventRoute = (event: Event): Route | undefined => {
  const fleet = useFleet();
  const { data: routes } = useRoutes();
  const uses_global_routefile = !!fleet.config.portal_config?.uses_global_routefile;

  if (!event) {
    return undefined;
  }

  if (uses_global_routefile) {
    const globalRoutefile = routes?.find((r) => r.is_global);
    if (globalRoutefile) {
      return globalRoutefile;
    }
  }

  return routes?.find((r) => String(r.id) === String(event?.route_id));
};
